import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { AppDatePipe } from '@app/pipes';

@Component({
    selector: 'time-tracking-dashboard-widget',
    templateUrl: './time-tracking-dashboard-widget.template.html',
    styleUrls: ['./time-tracking-dashboard-widget.style.scss'],
})
export class TimeTrackingDashboardWidget {
    @Input() minutesToday = 0;
    @Input() minutesYesterday = 0;
    /**
     * Ensures that the buttons are the same width and always the width of the largest button.
     * This ensures a dynamic solution that works even when copy changes or language
     */
    @ViewChild('buttonsBox') set buttonsBox(buttonsBox: ElementRef) {
        // When the containing div loads into the DOM we calculate the largest button width of the two children
        this.buttonMaxWidth =
            Math.max(
                ...Array.from((<HTMLElement>buttonsBox.nativeElement).querySelectorAll('ui-button')).map(
                    ({ clientWidth }) => clientWidth
                )
            ) + 'px';
    }
    buttonMaxWidth = 'max-content';

    today = new Date();
    dayOfTheWeek: string;
    dayOfMonth: number;
    abbreviatedMonth: string;

    timeWorkedToday = '';
    timeWorkedYesterday = '';

    constructor() {
        // set the display values for today's date
        // these values will not change
        const datePipe = new AppDatePipe();
        const now = new Date();
        this.dayOfMonth = now.getDate();
        this.dayOfTheWeek = datePipe.transform(now, 'EEEE') ?? '';
        this.abbreviatedMonth = datePipe.transform(now, 'LLL') ?? '';
    }

    ngOnChanges(): void {
        this.calculateHoursAndMinutes();
    }

    /**
     * calculateHoursAndMinutes prepares the time strings for the template
     */
    private calculateHoursAndMinutes(): void {
        const hoursToday = Math.floor(this.minutesToday / 60);
        const minutesToday = this.minutesToday % 60;
        const hoursYesterday = Math.floor(this.minutesYesterday / 60);
        const minutesYesterday = this.minutesYesterday % 60;

        // create the time strings, with a leading 0 for minutes if needed
        this.timeWorkedToday = `${hoursToday}h ${minutesToday < 10 ? '0' : ''}${minutesToday}m`;
        this.timeWorkedYesterday = `${hoursYesterday}h ${minutesYesterday < 10 ? '0' : ''}${minutesYesterday}m`;
    }
}
